import type { ReactNode } from 'react'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded'
import BlockRoundedIcon from '@mui/icons-material/BlockRounded'
import './ControlNotice.css'

export type ControlNoticeTone = 'info' | 'warning' | 'danger' | 'muted'

export interface ControlNoticeProps {
  message: ReactNode
  title?: string
  tone?: ControlNoticeTone
  icon?: ReactNode
  action?: ReactNode
  className?: string
  testId?: string
}

export const ControlNotice = ({
  message,
  title,
  tone = 'muted',
  icon,
  action,
  className = '',
  testId = 'control-notice',
}: ControlNoticeProps) => {
  const defaultIcon =
    tone === 'danger' ? (
      <BlockRoundedIcon fontSize="small" />
    ) : tone === 'warning' ? (
      <WarningAmberRoundedIcon fontSize="small" />
    ) : (
      <InfoOutlinedIcon fontSize="small" />
    )

  return (
    <div
      role="status"
      data-testid={testId}
      className={`controlNotice controlNotice--${tone} ${className}`.trim()}
    >
      <span className="controlNotice__icon" aria-hidden="true">
        {icon ?? defaultIcon}
      </span>
      <div className="controlNotice__content">
        {title ? <strong className="controlNotice__title">{title}</strong> : null}
        <div className="controlNotice__message">{message}</div>
      </div>
      {action ? <div className="controlNotice__action">{action}</div> : null}
    </div>
  )
}
